module.exports = __webpack_public_path__ + "static/media/transpak_logo.5808ee59.png";